// extracted by mini-css-extract-plugin
export default {"formBox":"Form_formBox__L1d6x","btn":"Form_btn__CTm9J","form":"Form_form__yKJiu","heading":"Form_heading__J3to3","inputs":"Form_inputs__YUU86","formInside":"Form_formInside__MFeqz"};